<section [class.content]="prescriptionPageObject?.ShowFilter">
  <div class="" [class.container-fluid]="prescriptionPageObject?.ShowFilter">
    <div class="block-header">
      <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div
            [hidden]="!prescriptionPageObject?.ShowFilter"
            class="col-12 col-xs-9 col-sm-9 col-md-9 col-lg-9"
          >
            <ul class="breadcrumb breadcrumb-style">
              <li class="breadcrumb-item">
                <h4 class="page-title">{{prescriptionPageObject?.Title}}</h4>
              </li>
              <li
                *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
                class="breadcrumb-item bcrumb-1"
              >
                <a routerLink="/pharmacist/dashboard">
                  <i class="fas fa-home"></i> Home</a
                >
              </li>
              <li
                *ngIf="currentUser.UserRoleId == 2"
                class="breadcrumb-item bcrumb-1"
              >
                <a routerLink="/doctor/dashboard">
                  <i class="fas fa-home"></i> Home</a
                >
              </li>
              <li
                *ngIf="currentUser.UserRoleId == 2"
                class="breadcrumb-item active"
              >
                My Prescriptions
              </li>
              <li
                *ngIf="currentUser.UserRoleId != 2"
                class="breadcrumb-item active text-capitalize"
              >
                Prescriptions
              </li>
            </ul>
          </div>
          <div class="col-12 col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <button
              [hidden]="!prescriptionPageObject?.ShowFilter || currentUser.UserRoleId!=2"
              mat-raised-button
              class="custom-button pull-right"
              routerLink="../create"
            >
              CREATE PRESCRIPTION
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="header" [class.pb-0]="!prescriptionPageObject?.ShowFilter">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            [class.prescription-header]="prescriptionPageObject?.ShowFilter"
          >
            <div class="row p-b-10 justify-content-between">
              <h2 class="w-auto">{{prescriptionPageObject?.Title}}</h2>
            </div>
            <div [hidden]="!prescriptionPageObject?.ShowFilter" class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <form
                  [formGroup]="searchPatientForm"
                  (ngSubmit)="searchPrescription()"
                >
                  <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                      <input
                        placeholder="Patient First Name"
                        class="border-0 form-control rounded-pill"
                        formControlName="patientFirstName"
                      />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                      <input
                        placeholder="Patient Last Name"
                        class="border-0 form-control rounded-pill"
                        formControlName="patientLastName"
                      />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                      <input
                        placeholder="Prescription No."
                        class="border-0 form-control rounded-pill"
                        formControlName="prescriptionNo"
                      />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                      <mat-select
                        name="status"
                        id="status"
                        class="border-0 form-control rounded-pill dropdownField"
                        aria-placeholder="Select Status"
                        formControlName="status"
                      >
                        <mat-option selected value="">Select Status</mat-option>
                        <mat-option value="FILLED">Filled</mat-option>
                        <mat-option value="PARTIALLY FILLED"
                          >Partially Filled</mat-option
                        >
                        <mat-option value="IN PROGRESS">In Progress</mat-option>
                        <mat-option value="PENDING">Pending</mat-option>
                        <mat-option value="CANCELLED">Cancelled</mat-option>
                      </mat-select>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12 p-t-5"
                    >
                      <mat-select
                        name="isReadyToCollect"
                        id="isReadyToCollect"
                        class="border-0 form-control rounded-pill"
                        aria-placeholder="Is Ready to Collect"
                        formControlName="isReadyToCollect"
                      >
                        <mat-option selected [value]="-1"
                          >Is Ready to Collect?</mat-option
                        >
                        <mat-option value="1">Yes</mat-option>
                        <mat-option value="0">No</mat-option>
                      </mat-select>
                    </div>
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12"
                    ></div>
                    <div
                      class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12"
                    ></div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                      <div
                        class="custom-icon-wrapper icon-button-demo float-end p-t-5"
                      >
                        <button color="primary" mat-mini-fab type="submit">
                          <mat-icon>search</mat-icon>
                        </button>
                        <button
                          (click)="reset()"
                          class="custom-button"
                          mat-mini-fab
                        >
                          <mat-icon>refresh</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div
          class="body"
          [class.pt-0]="!prescriptionPageObject?.ShowFilter"
          [class.pe-0]="!prescriptionPageObject?.ShowFilter"
          [class.px-0]="!prescriptionPageObject?.ShowFilter"
        >
          <div class="table-responsive">
            <mat-table
              *ngIf="records?.length!=0"
              #table
              [dataSource]="records"
              matSort
              class="mat-cell"
            >
              <ng-container matColumnDef="Profile">
                <mat-header-cell
                  mat-header-cell
                  *matHeaderCellDef
                  [ngClass]="'tbl-col-width-per-12'"
                >
                </mat-header-cell>
                <mat-cell
                  mat-cell
                  *matCellDef="let row"
                  class="table-img tbl-col-width-per-12"
                >
                  <app-profile-pic
                    *ngIf="row.Patient?.ProfilePictureId!=0 && row.Patient?.ProfilePictureId!=null"
                    [documentId]="row.Patient?.ProfilePictureId"
                    [type]="'thumb'"
                    [userType]="'patient'"
                  >
                  </app-profile-pic>

                  <img
                    *ngIf="!(row.Patient?.ProfilePictureId!=0 && row.Patient?.ProfilePictureId!=null)"
                    src="{{'../assets/images/user/patient-1.png'}}"
                    width="32"
                    height="32"
                    alt="User"
                  />
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Name">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  [ngClass]="'customWidthClass'"
                  (click)="sortBy('patientName')"
                  style="text-align: left;"
                  >Patient Name<i
                    *ngIf="paginationVM.SortOrder == true && paginationVM.SortBy == 'patientName'"
                    class="fas fa-angle-up"
                  ></i
                  ><i
                    *ngIf="paginationVM.SortOrder == false && paginationVM.SortBy == 'patientName'"
                    class="fas fa-angle-down"
                  ></i
                ></mat-header-cell>
                <mat-cell
                  *matCellDef="let row"
                  [ngClass]="'customWidthClass'"
                  class="text-info text-capitalize"
                  (click)="viewPatientCall(row)"
                  matTooltip="{{row.Patient.FirstName}} {{row.Patient.LastName}}"
                  matTooltipPosition="left"
                >
                  {{row.Patient.FirstName }}&nbsp; {{ (row.Patient.LastName) }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="CreatedDate">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  [ngClass]="'customWidthClass text-center'"
                  (click)="sortBy('CreatedDate')"
                  >Date Of Prescription<i
                    *ngIf="paginationVM.SortOrder == true && paginationVM.SortBy == 'CreatedDate'"
                    class="fas fa-angle-up"
                  ></i
                  ><i
                    *ngIf="paginationVM.SortOrder == false && paginationVM.SortBy == 'CreatedDate'"
                    class="fas fa-angle-down"
                  ></i>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row"
                  [ngClass]="'customWidthClass text-center'"
                >
                  {{ row.Prescription?.CreatedDate | date:'MM/dd/yy' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="No">
                <mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  [ngClass]="'customWidthClass'"
                  mat-sort-header
                  (click)="sortBy('prescriptionNo')"
                  >Prescription#
                  <i
                    *ngIf="paginationVM.SortOrder == true && paginationVM.SortBy == 'prescriptionNo'"
                    class="fas fa-angle-up"
                  ></i
                  ><i
                    *ngIf="paginationVM.SortOrder == false && paginationVM.SortBy == 'prescriptionNo'"
                    class="fas fa-angle-down"
                  ></i
                ></mat-header-cell>
                <mat-cell
                  style="text-align: center;"
                  *matCellDef="let row"
                  [ngClass]="'customWidthClass'"
                  class="text-info text-center"
                  (click)="viewPrescription(row)"
                >
                  {{ row.Prescription?.PrescriptionNo }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Medicine#">
                <mat-header-cell
                  *matHeaderCellDef
                  style="padding-left: 55px;"
                  mat-sort-header
                  >Medicine#</mat-header-cell
                >
                <mat-cell
                  class="text-right justify-content-center"
                  *matCellDef="let row"
                  >{{ row?.PrescriptionDetails?.length }}</mat-cell
                >
              </ng-container>

              <ng-container matColumnDef="Status">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  >Status</mat-header-cell
                >
                <mat-cell *matCellDef="let row">
                  <div
                    style="color: black;"
                    class="customWidthClass text-center w-100"
                    [ngClass]="row.Prescription.Class"
                    [ngStyle]="row.Prescription.Status == 'CANCELLED'?{'text-decoration':'line-through'}:
                    {'text-decoration':'none'}"
                  >
                    <span class="text-capitalize">
                      {{ row.Prescription?.Status }}</span
                    >
                  </div>
                </mat-cell>
              </ng-container>

              <!-- actions -->
              <ng-container matColumnDef="actions">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngClass]="'customWidth p-l-45'"
                  >Actions</mat-header-cell
                >
                <mat-cell
                  *matCellDef="let row; let i = index"
                  [ngClass]="'customWidth p-l-40'"
                >
                  <button
                    mat-icon-button
                    color="accent"
                    class="btn-tbl-confirm"
                    (click)="downloadPrescription(row)"
                    title="Download Prescription"
                  >
                    <mat-icon aria-label="file_download" class="col-white"
                      >file_download</mat-icon
                    >
                  </button>
                  <!-- <button
                    *ngIf="prescriptionPageObject?.Title != 'PENDING PRESCRIPTION'"
                    [disabled]="row.Prescription.Status=='PENDING' || row.Prescription.Status=='IN PROGRESS'"
                    [ngStyle]="row.Prescription.Status=='PENDING' || row.Prescription.Status=='IN PROGRESS'?{'cursor': 'not-allowed'} : {'cursor': 'pointer'}"
                    mat-mini-fab
                    color="warn"
                    class="btn-tbl-reject"
                    (click)="deleteItem(i, row)"
                    title="Cancel Prescription"
                  >
                    <mat-icon aria-label="Delete" class="col-white"
                      >cancel</mat-icon
                    >
                  </button> -->
                  <button
                    *ngIf="prescriptionPageObject?.Title != 'PENDING PRESCRIPTION'"
                    [disabled]="row.Prescription.Status!='PENDING'"
                    [ngStyle]="row.Prescription.Status!='PENDING'?{'cursor': 'not-allowed'} : {'cursor': 'pointer'}"
                    mat-mini-fab
                    color="warn"
                    class="btn-tbl-reject"
                    (click)="CancelItem(i, row)"
                    title="Cancel Prescription"
                  >
                    <mat-icon aria-label="Delete" class="col-white"
                      >cancel</mat-icon
                    >
                  </button>

                  <button
                    [disabled]="
                    (row.Prescription.IsLockBy != currentUser.Id && row.Prescription.IsLock == 1) 
                    || (row.Prescription.Status == 'FILLED' || row.Prescription.Status == 'CANCELLED')"
                    [ngStyle]="(row.Prescription.IsLockBy != currentUser.Id && row.Prescription.IsLock == 1) 
                    || (row.Prescription.Status == 'FILLED' || row.Prescription.Status == 'CANCELLED')
                    ?{'cursor': 'not-allowed'} : {'cursor': 'pointer'}"
                    *ngIf="(currentUser.UserRoleId != 2 && row.Prescription.Status!='IN PROGRESS') || currentUser.UserRoleId != 2"
                    mat-mini-fab
                    color="grey"
                    class="btn-tbl-edit"
                    (click)="EditItem(i, row)"
                    title="Edit Prescription"
                  >
                    <mat-icon aria-label="edit" class="col-white"
                      >edit</mat-icon
                    >
                  </button>

                  <button
                    [ngClass]="{'d-none':currentUser.UserRoleId == 3 || currentUser.UserRoleId == 4}"
                    mat-mini-fab
                    color="grey"
                    class="btn-tbl-edit"
                    (click)="CloneItem(i, row)"
                    title="Prescribe Again"
                  >
                    <mat-icon aria-label="edit" class="col-white"
                      >repeat</mat-icon
                    >
                  </button>
                  <button
                    [ngClass]="{'invisible':(row.Prescription.IsLock == true && row.Prescription.IsLockBy == currentUser.Id) || (row.Prescription.IsLock == false) || currentUser.UserRoleId == 2 || row.Prescription.Status=='PENDING'}"
                    mat-icon-button
                    color="accent"
                    class="btn-tbl-edit"
                    (click)="updateItem(i, row)"
                    title="Unlock Prescription"
                  >
                    <mat-icon aria-label="Lock" class="col-white"
                      >lock</mat-icon
                    >
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row
                [style.background]="'#f5f5f5'"
                *matHeaderRowDef="prescriptionPageObject.ColumnList"
              ></mat-header-row>
              <!-- <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row> -->
              <mat-row
                *matRowDef="let row; columns: prescriptionPageObject.ColumnList"
                [style.cursor]="'pointer'"
                matRipple
              >
              </mat-row>
            </mat-table>
            <div *ngIf="records?.length == 0" class="text-center">
              <!-- No Prescription To Display -->
              No data to display
            </div>
            <mat-paginator
              *ngIf="records.length != 0 && prescriptionPageObject?.ShowFilter && paginationVM?.TotalCount>10"
              (page)="handlePage($event)"
              #paginator
              [length]="paginationVM?.TotalCount"
              [pageIndex]="paginationVM.PageNumber-1"
              [pageSize]="paginationVM?.PageSize"
              showFirstLastButtons="firstLastButtons"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #DeletePrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to delete this prescription# <br />
      <span class="text-info">{{ prescription.PrescriptionNo }}</span>&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="deletePrescription()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #UpdatePrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to unlock this prescription# <br />
      <span class="text-info">{{ prescription.PrescriptionNo }}</span>&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="updatePrescription()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #EditPrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to #Refill this prescription# <br />
      <span class="text-info">{{ prescription.PrescriptionNo }}</span>&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="RedirectTOFill()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ClonePrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to prescribe again this prescription# <br />
      <span class="text-info">{{ prescription.PrescriptionNo }}</span>&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="ClonePrescription()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #CancelPrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to cancel this prescription#
      <span class="text-info">{{ prescription.PrescriptionNo }}</span>
      ?<br />You will not be allowed to fill this prescription later.
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-5">
          <button
            type="button"
            (click)="CancelPrescription()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>

          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
